export const messages = {
  en: {
    menuCatalogManage: {
      queryCondition: 'Query Conditions',
      enterMenuGroupName: 'Please enter menu group name',
      selectStoreType: 'Please select store type',
      selectIsShow: 'Please select whether to show',
      query: 'Query',
      reset: 'Reset',
      menuCatalog: 'Menu Catalog',
      add: 'Add',
      number: 'Number',
      menuGroupName: 'Menu Group Name',
      icon: 'Icon',
      sequence: 'Sequence',
      storeType: 'Store Type',
      page: 'Page',
      isShow: 'Is Show',
      operation: 'Operation',
      edit: 'Edit',
      menuGroup: 'Menu Group',
      delete: 'Delete',
      yes: 'Yes',
      no: 'No',
      pleaseSelect: 'Please select',
      operationTeam: 'Operation Team',
      merchant: 'Merchant',
      developmentTeam: 'Development Team',
      agent: 'Agent',
      logisticsCompany: 'Logistics Company',
      runErrands: 'Run Errands',
      unknown: 'Unknown'
    },
    addMenuCatalog: {
      add: 'Add',
      name: 'Name',
      icon: 'Icon',
      sequence: 'Sequence',
      storeType: 'Store Type',
      page: 'Page',
      isShow: 'Is Show',
      requiredName: 'Required, please fill in the name',
      requiredIcon: 'Required, please fill in the icon',
      requiredSequence: 'Required, please fill in the sequence',
      requiredStoreType: 'Required, please select store type',
      requiredPage: 'Required, please fill in the page',
      requiredIsShow: 'Required, please select whether to show',
      cancel: 'Cancel',
      save: 'Save',
      nameRequired: 'Name cannot be empty',
      nameMaxLength: 'Name cannot exceed 10 characters',
      iconRequired: 'Icon cannot be empty',
      iconMaxLength: 'Icon cannot exceed 20 characters',
      seqRequired: 'Sequence cannot be empty',
      seqMaxLength: 'Sequence cannot exceed 11 characters',
      storeTypeRequired: 'Store type cannot be empty',
      urlRequired: 'Page cannot be empty',
      urlMaxLength: 'Page cannot exceed 256 characters',
      isShowRequired: 'Is show cannot be empty',
      addSuccess: 'Add successfully'
    },
    editMenuCatalog: {
      edit: 'Edit',
      name: 'Name',
      icon: 'Icon',
      sequence: 'Sequence',
      storeType: 'Store Type',
      page: 'Page',
      isShow: 'Is Show',
      requiredName: 'Required, please fill in the name',
      requiredIcon: 'Required, please fill in the icon',
      requiredSequence: 'Required, please fill in the sequence',
      requiredStoreType: 'Required, please select store type',
      requiredPage: 'Required, please fill in the page',
      requiredIsShow: 'Required, please select whether to show',
      cancel: 'Cancel',
      save: 'Save',
      nameRequired: 'Name cannot be empty',
      nameMaxLength: 'Name cannot exceed 10 characters',
      iconRequired: 'Icon cannot be empty',
      iconMaxLength: 'Icon cannot exceed 20 characters',
      seqRequired: 'Sequence cannot be empty',
      seqMaxLength: 'Sequence cannot exceed 11 characters',
      storeTypeRequired: 'Store type cannot be empty',
      urlRequired: 'Page cannot be empty',
      urlMaxLength: 'Page cannot exceed 256 characters',
      isShowRequired: 'Is show cannot be empty',
      idRequired: 'ID cannot be empty',
      editSuccess: 'Edit successfully'
    },
    deleteMenuCatalog: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteMenuCatalog: 'Confirm to delete menu catalog',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    menuCatalogManage: {
      queryCondition: '查询条件',
      enterMenuGroupName: '请输入菜单组名称',
      selectStoreType: '请选择商户类型',
      selectIsShow: '请选择是否显示',
      query: '查询',
      reset: '重置',
      menuCatalog: '菜单目录',
      add: '添加',
      number: '编号',
      menuGroupName: '菜单组名称',
      icon: '图标',
      sequence: '顺序',
      storeType: '商户类型',
      page: '页面',
      isShow: '是否显示',
      operation: '操作',
      edit: '修改',
      menuGroup: '菜单组',
      delete: '删除',
      yes: '是',
      no: '否',
      pleaseSelect: '请选择',
      operationTeam: '运营团队',
      merchant: '商家',
      developmentTeam: '开发团队',
      agent: '代理商',
      logisticsCompany: '物流公司',
      runErrands: '跑腿',
      unknown: '未知'
    },
    addMenuCatalog: {
      add: '添加',
      name: '名称',
      icon: '图标',
      sequence: '顺序',
      storeType: '商户类型',
      page: '页面',
      isShow: '是否显示',
      requiredName: '必填，请填写名称',
      requiredIcon: '必填，请填写图标',
      requiredSequence: '必填，请填写顺序',
      requiredStoreType: '必填，请选择商户类型',
      requiredPage: '必填，请填写页面',
      requiredIsShow: '必填，请选择是否显示',
      cancel: '取消',
      save: '保存',
      nameRequired: '名称不能为空',
      nameMaxLength: '名称不能超过10个字符',
      iconRequired: '图标不能为空',
      iconMaxLength: '图标不能超过20个字符',
      seqRequired: '顺序不能为空',
      seqMaxLength: '顺序不能超过11个字符',
      storeTypeRequired: '商户类型不能为空',
      urlRequired: '页面不能为空',
      urlMaxLength: '页面不能超过256个字符',
      isShowRequired: '是否显示不能为空',
      addSuccess: '添加成功'
    },
    editMenuCatalog: {
      edit: '修改',
      name: '名称',
      icon: '图标',
      sequence: '顺序',
      storeType: '商户类型',
      page: '页面',
      isShow: '是否显示',
      requiredName: '必填，请填写名称',
      requiredIcon: '必填，请填写图标',
      requiredSequence: '必填，请填写顺序',
      requiredStoreType: '必填，请选择商户类型',
      requiredPage: '必填，请填写页面',
      requiredIsShow: '必填，请选择是否显示',
      cancel: '取消',
      save: '保存',
      nameRequired: '名称不能为空',
      nameMaxLength: '名称不能超过10个字符',
      iconRequired: '图标不能为空',
      iconMaxLength: '图标不能超过20个字符',
      seqRequired: '顺序不能为空',
      seqMaxLength: '顺序不能超过11个字符',
      storeTypeRequired: '商户类型不能为空',
      urlRequired: '页面不能为空',
      urlMaxLength: '页面不能超过256个字符',
      isShowRequired: '是否显示不能为空',
      idRequired: '编号不能为空',
      editSuccess: '修改成功'
    },
    deleteMenuCatalog: {
      confirmOperation: '请确认您的操作',
      confirmDeleteMenuCatalog: '确定删除菜单目录',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}